export default __webpack_public_path__ + "static/media/flag-12.5e031355.gif";